import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-wild-sand p-x2 mt-x4 w-4/5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "mt-x2"
}
const _hoisted_4 = {
  key: 0,
  class: "mt-x2"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-x2"
}
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "c-magic-line c-magic-line--underline text-dusty-grey" }
const _hoisted_8 = { class: "mt-x3 mb-x4 sm:mb-x6" }

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import useOutletProductDetailData from '@/shared/product/details/ui/outlet/useOutletProductDetailData';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import { ref } from 'vue';
import OutletHubInfo from '@/shared/product/details/ui/outlet/OutletHubInfo.vue';
import OutletStoreInfo from '@/shared/product/details/ui/outlet/OutletStoreInfo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OutletRemarks',
  setup(__props) {

const { outletProductData: productData } = useOutletProductDetailData();

const labels = useBlockLabels();

const showDialog = ref(false);

const openDialog = () => {
    showDialog.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(labels).remarksHeading)
        ? (_openBlock(), _createElementBlock("strong", _hoisted_2, _toDisplayString(_unref(labels).remarksHeading), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productData).damageDescriptions, (damageDescription) => {
        return (_openBlock(), _createElementBlock("p", {
          key: damageDescription,
          class: "mt-x2"
        }, _toDisplayString(damageDescription), 1))
      }), 128)),
      (_unref(productData).isConsignment)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(labels).noOutletLocation), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_unref(productData).canBeDelivered)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(labels).canBeDelivered), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(labels).canBePickedUp), 1))
          ], 64)),
      (_unref(productData).outletLocation?.name)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            title: _unref(productData).outletLocation?.name,
            class: "leading-22px mt-x2",
            onClick: openDialog
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(productData).outletLocation?.name), 1)
          ], 8, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _createVNode(BaseDialog, {
      "is-open": showDialog.value,
      class: "fixed inset-x-0 p-x3 sm:p-30 mx-auto mt-x4 z-1 text-center bg-white sm:relative sm:inset-auto w-screen-90 sm:h-auto sm:w-screen-80 md:px-x5 md:pb-x3 md:max-w-850",
      onClose: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_8, _toDisplayString(_unref(productData).outletLocation?.name), 1),
        (_unref(productData).outletLocation?.isStorage)
          ? (_openBlock(), _createBlock(OutletHubInfo, {
              key: 0,
              "hub-id": _unref(productData).outletLocation.hub
            }, null, 8, ["hub-id"]))
          : (_openBlock(), _createBlock(OutletStoreInfo, {
              key: 1,
              "store-id": _unref(productData).outletLocation?.storeId
            }, null, 8, ["store-id"]))
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}
}

})